import { ModelCollection } from '/@/modules/core/app/models/ModelCollection';
import { ExtractedUser } from '@/modules/ai/models/ExtractedUser';
import { ExtractedEntityCategoryTypeKey } from '@/modules/ai/constants/ExtractedEntityCategoryTypeKey';

export class ExtractedUserCollection extends ModelCollection<ExtractedUser> {
  constructor(items: ExtractedUser[] | ExtractedUserCollection | null = null) {
    super(items, ExtractedUser);
  }

  static mapModel(
    items: ExtractedUser[] | ExtractedUserCollection | null = null
  ): ExtractedUserCollection {
    return new this(items);
  }

  get primaryExecutors(): ExtractedUser[] {
    return (
      this.items?.filter(
        (item: ExtractedUser) => item.category === ExtractedEntityCategoryTypeKey.PRIMARY_EXECUTORS
      ) ?? []
    );
  }

  get alternateExecutors(): ExtractedUser[] {
    return (
      this.items?.filter(
        (item: ExtractedUser) =>
          item.category === ExtractedEntityCategoryTypeKey.ALTERNATE_EXECUTORS
      ) ?? []
    );
  }

  get residualBeneficiaries(): ExtractedUser[] {
    return (
      this.items?.filter(
        (item: ExtractedUser) =>
          item.category === ExtractedEntityCategoryTypeKey.PRIMARY_RESIDUAL_BENEFICIARIES
      ) ?? []
    );
  }

  get alternateResidualBeneficiaries(): ExtractedUser[] {
    return (
      this.items?.filter(
        (item: ExtractedUser) =>
          item.category === ExtractedEntityCategoryTypeKey.ALTERNATE_RESIDUAL_BENEFICIARIES
      ) ?? []
    );
  }

  get specificBeneficiaries(): ExtractedUser[] {
    return (
      this.items?.filter(
        (item: ExtractedUser) =>
          item.category === ExtractedEntityCategoryTypeKey.PRIMARY_SPECIFIC_BENEFICIARIES
      ) ?? []
    );
  }

  get alternateSpecificBeneficiaries(): ExtractedUser[] {
    return (
      this.items?.filter(
        (item: ExtractedUser) =>
          item.category === ExtractedEntityCategoryTypeKey.ALTERNATE_SPECIFIC_BENEFICIARIES
      ) ?? []
    );
  }

  get pendingUsers(): ExtractedUser[] {
    return this.items?.filter((user: ExtractedUser): boolean => !user.isValidated) ?? [];
  }

  get validatedUsers(): ExtractedUser[] {
    return this.items?.filter((user: ExtractedUser): boolean => !!user.isValidated) ?? [];
  }

  get areAllValidated(): boolean {
    return this.hasItems && this.pendingUsers.length === 0;
  }
}
